<!-- Widget Payment History — Display-only, iframe embeddable -->
<div class="bg-transparent py-1">
    <div class="container-fluid px-2">

        <!-- Widget Errors -->
        <div *ngIf="error && !loading" class="text-center py-3">
            <div *ngIf="errorType === 'auth'" class="alert alert-warning py-2 small">
                <i class="fas fa-key me-1"></i> {{ error }}
            </div>
            <div *ngIf="errorType === 'permission'" class="alert alert-danger py-2 small">
                <i class="fas fa-lock me-1"></i> {{ error }}
            </div>
            <div *ngIf="errorType === 'network' || errorType === ''" class="alert alert-danger py-2 small">
                <i class="fas fa-exclamation-triangle me-1"></i> {{ error }}
                <br><button class="btn btn-sm btn-outline-danger mt-1" (click)="loadPayments()"><i class="fas fa-redo me-1"></i>Reintentar</button>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <p class="text-muted small mt-1 mb-0">Cargando pagos...</p>
        </div>

        <ng-container *ngIf="!loading && !error">

            <!-- Buscador -->
            <div class="mb-2">
                <div class="input-group input-group-sm">
                    <span class="input-group-text bg-white"><i class="fas fa-search text-muted"></i></span>
                    <input type="text" class="form-control form-control-sm" placeholder="Buscar por código, referencia, monto, banco..."
                        [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
                    <button *ngIf="searchTerm" class="btn btn-outline-secondary btn-sm" type="button" (click)="searchTerm=''; onSearchChange()">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <!-- Filtros de estatus -->
            <div class="d-flex flex-wrap gap-1 mb-2">
                <button class="btn btn-sm filter-pill" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">
                    Todos <span class="badge bg-secondary ms-1">{{ filterCounts.all }}</span>
                </button>
                <button class="btn btn-sm filter-pill" [class.active]="activeFilter === 'APPROVED'" (click)="setFilter('APPROVED')">
                    <i class="fas fa-check-circle text-success me-1"></i>Aprobados <span class="badge bg-success ms-1">{{ filterCounts.approved }}</span>
                </button>
                <button class="btn btn-sm filter-pill" [class.active]="activeFilter === 'PENDING'" (click)="setFilter('PENDING')">
                    <i class="fas fa-clock text-warning me-1"></i>Por conciliar <span class="badge bg-warning text-dark ms-1">{{ filterCounts.pending }}</span>
                </button>
                <button class="btn btn-sm filter-pill" [class.active]="activeFilter === 'REJECTED'" (click)="setFilter('REJECTED')">
                    <i class="fas fa-ban text-danger me-1"></i>Anulado/Rechazado <span class="badge bg-danger ms-1">{{ filterCounts.rejected }}</span>
                </button>
            </div>

            <!-- Resultados -->
            <ng-container *ngFor="let item of visiblePayments">
                <div class="card card-compact mb-2 shadow-sm">
                    <div class="card-body py-2 px-3">

                        <!-- Fila 1: Código + Estatus -->
                        <div class="d-flex justify-content-between align-items-start mb-1">
                            <div>
                                <span class="text-muted fz-11">Código</span>
                                <div class="fw-bold fz-13">{{item?.payment?.code}}</div>
                            </div>
                            <div class="text-end">
                                <!-- Aprobado -->
                                <span class="badge text-bg-success fz-11" *ngIf="item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='DOMICILIATION'">Aprobado</span>
                                <span class="badge text-bg-success fz-11" *ngIf="item?.payment?.reconciled_payment && item?.payment?.typeTransaction==='DOMICILIATION' && item?.payment?.amount>0 && item?.payment?.status">Aprobado</span>
                                <span class="badge text-bg-danger fz-11" *ngIf="item?.payment?.reconciled_payment && item?.payment?.typeTransaction==='DOMICILIATION' && item?.payment?.amount===0">{{item?.payment?.description}}</span>
                                <!-- Por conciliar -->
                                <span class="badge text-bg-warning fz-11" *ngIf="!item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'">Por conciliar</span>
                                <span class="badge text-bg-warning fz-11" *ngIf="!item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction==='PENDING'">En validación</span>
                                <!-- Anulado -->
                                <span class="badge text-bg-danger fz-11" *ngIf="!item?.payment?.status && item?.payment?.typeTransaction!=='DOMICILIATION'">{{item?.payment?.typeTransaction == 'AUTO'?'Transacción fallida':'Anulado'}}</span>
                                <span class="badge text-bg-danger fz-11" *ngIf="!item?.payment?.status && item?.payment?.typeTransaction==='DOMICILIATION'">Rechazado por el Banco</span>
                            </div>
                        </div>

                        <!-- Fila 2: Monto + Conciliación -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Monto</span>
                                <div class="fw-bold fz-13">{{item?.payment?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Conciliación</span>
                                <div class="fw-bold fz-12" *ngIf="item?.payment?.typeTransaction !== 'DOMICILIATION'"
                                    [ngClass]="{'text-success': item?.payment?.typeTransaction == 'AUTO','text-secondary': item?.payment?.typeTransaction != 'AUTO'}">
                                    {{item?.payment?.typeTransaction == 'AUTO'? item?.payment?.responseAutoConfirm?.source?findAutopago(item?.payment?.responseAutoConfirm?.source):'Auto':(item?.payment?.typeTransaction==='PENDING'?'Automática':'Manual')}}
                                </div>
                                <div class="fw-bold fz-12 text-secondary" *ngIf="item?.payment?.typeTransaction === 'DOMICILIATION'">
                                    Domiciliado {{ item?.payment?.account_payment?.bank?.name }}
                                </div>
                            </div>
                        </div>

                        <!-- Fila 3: Tasa + Contra valor -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Tasa</span>
                                <div class="fw-bold fz-12">1 USD = {{item?.payment?.rate | currency:'USD':'': '1.2-2'}} BS</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Contra valor</span>
                                <div class="fw-bold fz-12">{{item?.payment?.counterValue | currency:'USD':'': '1.2-2'}} {{item?.payment?.currency?.name}}</div>
                            </div>
                        </div>

                        <!-- Fila 4: Tipo producto -->
                        <div class="mb-1">
                            <span class="text-muted fz-11">Tipo de producto</span>
                            <span class="fw-bold fz-12 ms-1">{{item?.payment?.typeProduct || 'CREDIT'}}</span>
                        </div>

                        <!-- Fila 5: Fechas -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Fecha reporte</span>
                                <div class="fz-12">{{item?.payment?.date | date: 'dd/MM/yyyy h:mm a'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Fecha pago</span>
                                <div class="fz-12">
                                    <ng-container *ngIf="item?.payment?.register_payment_date">{{ item?.payment?.register_payment_date | date: 'dd/MM/yyyy' }}</ng-container>
                                    <ng-container *ngIf="!item?.payment?.register_payment_date">{{ item?.payment?.date | date: 'dd/MM/yyyy' }}</ng-container>
                                </div>
                            </div>
                        </div>

                        <!-- Fila 6: Conciliación fecha + responsable -->
                        <div class="row gx-2 mb-1" *ngIf="item?.payment?.reconciled_payment_date || item?.payment?.reconciled_payment_ejecutive">
                            <div class="col-6">
                                <span class="text-muted fz-11">Fecha conciliación</span>
                                <div class="fz-12">{{item?.payment?.reconciled_payment_date | date: 'dd/MM/yyyy h:mm a'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Responsable</span>
                                <div class="fz-12 text-capitalize">{{item?.payment?.reconciled_payment_ejecutive?.name}} {{item?.payment?.reconciled_payment_ejecutive?.lastName}}</div>
                            </div>
                        </div>

                        <!-- Descripción / Motivo anulación -->
                        <div class="mb-1" *ngIf="item?.payment?.description">
                            <span class="text-muted fz-11">{{ item?.payment?.status ? 'Descripción' : 'Motivo de anulación' }}</span>
                            <div class="fz-12 fw-bold">{{item?.payment?.description}}</div>
                        </div>

                        <!-- Canal de reporte -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Canal</span>
                                <div class="fz-12 text-capitalize">
                                    <ng-container *ngIf="item?.payment?.creator_api">{{item?.payment?.creator_api}}</ng-container>
                                    <ng-container *ngIf="!item?.payment?.creator_api">-</ng-container>
                                    <ng-container *ngIf="item?.payment?.creator?.name"> / {{ item?.payment?.creator?.name }} {{ item?.payment?.creator?.lastName }}</ng-container>
                                </div>
                            </div>
                            <div class="col-6 text-end" *ngIf="item?.payment?.payment_edit_ejecutive">
                                <span class="text-muted fz-11">Editado por</span>
                                <div class="fz-12 text-capitalize">{{item?.payment?.payment_edit_ejecutive?.name}} {{item?.payment?.payment_edit_ejecutive?.lastName}}</div>
                            </div>
                        </div>

                        <!-- Banco origen + método -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Banco origen</span>
                                <div class="fz-12 fw-bold">{{(item?.payment?.bankCode && banks[item?.payment?.bankCode]) || '-'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Método de pago</span>
                                <div class="fz-12 fw-bold">{{item?.payment?.account_payment?.payment_method?.name || '-'}}</div>
                            </div>
                        </div>

                        <!-- Referencia + teléfono origen -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Referencia</span>
                                <div class="fz-12 fw-bold">{{item?.payment?.paymentMethodId || '-'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Teléfono origen</span>
                                <div class="fz-12">{{item?.payment?.phone || '-'}}</div>
                            </div>
                        </div>

                        <!-- Cuenta origen + cédula -->
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Cta. origen (últ. 6)</span>
                                <div class="fz-12">{{item?.payment?.account || '-'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Cédula/Rif titular</span>
                                <div class="fz-12">{{item?.payment?.cid != 'V' ? item?.payment?.cid : '-'}}</div>
                            </div>
                        </div>

                        <!-- Banco destino + cuenta + teléfono -->
                        <div class="row gx-2 mb-1">
                            <div class="col-12">
                                <span class="text-muted fz-11">Banco destino</span>
                                <span class="fz-12 fw-bold ms-1">{{item?.payment?.account_payment?.bank?.name || '-'}}</span>
                            </div>
                        </div>
                        <div class="row gx-2 mb-1">
                            <div class="col-6">
                                <span class="text-muted fz-11">Tel. destino</span>
                                <div class="fz-12">{{item?.payment?.account_payment?.phone || '-'}}</div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="text-muted fz-11">Cta. destino</span>
                                <div class="fz-12">{{item?.payment?.account_payment?.number || '-'}}</div>
                            </div>
                        </div>

                        <!-- Monto sin aplicar -->
                        <div class="mb-1" *ngIf="item?.payment?.totalPaymentDue > 0 && item?.payment?.status">
                            <span class="text-muted fz-11">Monto sin aplicar</span>
                            <span class="fz-12 fw-bold text-danger ms-1">{{item?.payment?.totalPaymentDue | currency:'USD':'': '1.2-2'}} USD</span>
                        </div>

                        <!-- Motivo rechazo domiciliación -->
                        <div class="mb-1" *ngIf="item?.payment?.automatic_direct_debit?.error">
                            <span class="text-muted fz-11">Motivo de Rechazo</span>
                            <div class="fz-12 text-danger">{{item?.payment?.automatic_direct_debit?.error?.description}}</div>
                        </div>

                        <!-- Adjunto con visor -->
                        <div *ngIf="item?.payment?.file" class="mb-1">
                            <a href="javascript:void(0)" class="fz-12 text-primary text-decoration-none" (click)="toggleFileViewer(item?.payment?.code)">
                                <i class="fas fa-paperclip me-1"></i>
                                {{ isFileVisible(item?.payment?.code) ? 'Ocultar adjunto' : 'Ver adjunto' }}
                            </a>
                            <!-- Visor inline -->
                            <div *ngIf="isFileVisible(item?.payment?.code)" class="mt-1 file-viewer-container">
                                <div *ngIf="isImage(item?.payment?.file)" class="text-center">
                                    <img [src]="getFileUrl(item?.payment?.file)" alt="Adjunto" class="img-fluid rounded" style="max-height: 300px; object-fit: contain;">
                                </div>
                                <div *ngIf="!isImage(item?.payment?.file)" class="text-center py-2">
                                    <i class="fas fa-file-pdf text-danger fz-25"></i>
                                    <div class="fz-12 mt-1">
                                        <a [href]="getFileUrl(item?.payment?.file)" target="_blank" class="btn btn-sm btn-outline-primary">
                                            <i class="fas fa-external-link-alt me-1"></i>Abrir PDF
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Voucher -->
                        <div *ngIf="item?.payment?.responseAutoConfirm" class="mt-1">
                            <div class="fz-11 fw-bold text-secondary">Voucher</div>
                            <div class="fz-11 mb-1" *ngIf="item?.payment?.responseAutoConfirm?.descripcion">{{item?.payment?.responseAutoConfirm?.descripcion}}</div>
                            <div *ngIf="item?.payment?.responseAutoConfirm?.voucher" class="voucher p-1 text-dark text-uppercase" [innerHTML]="item?.payment?.responseAutoConfirm?.voucher"></div>
                        </div>

                        <!-- Pago asíncrono (payment_pending) -->
                        <div *ngIf="item.payment.payment_pending" class="text-end mt-1">
                            <span class="badge fz-11" [class.text-bg-success]="item.payment.payment_pending.status==='PENDING'" [class.text-bg-secondary]="item.payment.payment_pending.status==='EXPIRED'" [class.text-bg-primary]="item.payment.payment_pending.status==='COMPLETE'"><i class="fas fa-clock"></i>&nbsp;Asíncrono</span>
                            <small class="d-block fz-11" *ngIf="item.payment.payment_pending.attempt > 0">{{ item.payment.payment_pending.attempt }} intento(s)</small>
                        </div>

                        <!-- Distribución -->
                        <div *ngIf="item?.installMent?.length > 0" class="mt-1 border-top pt-1">
                            <div class="fz-11 fw-bold text-secondary mb-1">Distribución</div>
                            <div class="row gx-2" *ngFor="let item2 of item?.installMent">
                                <div class="col-7">
                                    <div class="fz-11">
                                        {{item2?.installMent?.invoice?.identifier}} /
                                        {{ item2?.installMent?.order < 1 ? 'Inicial': 'Cuota '+ item2?.installMent?.order }}
                                    </div>
                                    <div class="fz-10 text-muted">{{item2?.installMent?.code}}</div>
                                </div>
                                <div class="col-5 text-end">
                                    <div class="fz-12 fw-bold">{{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                </div>
                            </div>
                        </div>

                        <!-- IGTF -->
                        <ng-container *ngIf="item?.paymen_categ_concept_deduc?.length > 0">
                            <div class="row gx-2" *ngFor="let item3 of item?.paymen_categ_concept_deduc">
                                <ng-container *ngIf="item3?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                                    <div class="col-8"><span class="fz-11">{{item3?.category_concept_deduction?.concept_deduction?.name}} <span class="text-muted" *ngIf="item3?.category_concept_deduction.isPorcent">{{item3?.category_concept_deduction?.amount}}%</span></span></div>
                                    <div class="col-4 text-end"><span class="fz-12">{{item3?.amount | currency:'USD':'': '1.2-2'}} USD</span></div>
                                </ng-container>
                            </div>
                        </ng-container>

                        <!-- Penalidades (fees) -->
                        <div *ngIf="item?.fees?.length > 0" class="mt-1 border-top pt-1">
                            <div class="fz-11 fw-bold text-secondary mb-1">Penalidades</div>
                            <div class="row gx-2" *ngFor="let item2 of item?.fees">
                                <div class="col-7">
                                    <div class="fz-11">
                                        {{item2?.fee_installment?.installment?.invoice?.identifier}} /
                                        {{ item2?.fee_installment?.installment?.order < 1 ? 'Inicial': 'Cuota '+ item2?.fee_installment?.installment?.order }}
                                    </div>
                                    <div class="fz-10 text-muted">{{item2?.fee_installment?.fee.concept_deduction?.name}}</div>
                                </div>
                                <div class="col-5 text-end">
                                    <div class="fz-12 fw-bold">{{item2?.amount | currency:'USD':'': '1.2-2'}} USD</div>
                                </div>
                            </div>
                        </div>

                        <!-- Penalidades alternativas -->
                        <div *ngIf="item?.payment?.fees?.length > 0 && item?.fees?.length === 0 && validar_penalidad(item?.payment?.fees)" class="mt-1 border-top pt-1">
                            <div class="fz-11 fw-bold text-secondary mb-1">Penalidad</div>
                            <ng-container *ngFor="let row of item?.paymen_categ_concept_deduc">
                                <div class="row gx-2" *ngIf="row?.fee && item?.payment?.reconciled_payment && item?.payment?.status && item?.payment?.typeTransaction!=='PENDING'">
                                    <div class="col-7">
                                        <div class="fz-11">{{ row?.installMent?.invoice?.identifier + ' / Cuota '+ row?.installMent?.order}}</div>
                                        <div class="fz-10 text-muted">{{ row?.fee?.concept_deduction?.name }}</div>
                                    </div>
                                    <div class="col-5 text-end">
                                        <div class="fz-12 fw-bold">{{feeService.calculateAmount(row?.fee) | currency:'USD':'': '1.2-2'}} USD</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Reporte de Seguros -->
                        <div *ngIf="item.payment.params?.insurance_report" class="text-end mt-1">
                            <span class="badge fz-10"
                                [class.text-bg-success]="item.payment.params.insurance_report.reportado"
                                [class.text-bg-warning]="!item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.current_intento > 0 && !item.payment.params.insurance_report.permanently_failed"
                                [class.text-bg-danger]="item.payment.params.insurance_report.permanently_failed"
                                [class.text-bg-info]="!item.payment.params.insurance_report.reportado && item.payment.params.insurance_report.current_intento === 0">
                                <i class="fas fa-file-medical-alt"></i>&nbsp;Seguro
                            </span>
                            <small class="d-block fz-10">{{ item.payment.params.insurance_report.current_intento || 0 }}/{{ item.payment.params.insurance_report.limite || 10 }} intentos</small>
                        </div>

                        <!-- Verificación Asíncrona -->
                        <div *ngIf="item.payment.async" class="text-end mt-1">
                            <span class="badge fz-10"
                                [class.text-bg-info]="item.payment.async.status==='PENDING'"
                                [class.text-bg-warning]="item.payment.async.status==='RETRYING'"
                                [class.text-bg-primary]="item.payment.async.status==='PROCESSING'"
                                [class.text-bg-success]="item.payment.async.status==='COMPLETED'"
                                [class.text-bg-danger]="item.payment.async.status==='FAILED'">
                                <i class="fas fa-robot"></i>&nbsp;Async
                            </span>
                            <small class="d-block fz-10">{{ item.payment.async.attempt || 0 }}/{{ item.payment.async.max_attempts || 0 }} intentos</small>
                        </div>

                        <!-- Alerta pagos similares -->
                        <div *ngIf="item?.payment?.status && item?.payment?.payments_similar?.length > 0" class="mt-1">
                            <div class="alert alert-warning py-1 px-2 fz-11 mb-0" *ngFor="let ps of item?.payment?.payments_similar">
                                <i class="fas fa-exclamation-triangle text-danger"></i> Pago similar: <b>{{ ps.code }}</b>
                            </div>
                        </div>

                    </div>
                </div>
            </ng-container>

            <!-- Ver más -->
            <div *ngIf="hasMore" class="text-center my-2">
                <button class="btn btn-sm btn-outline-primary w-100" (click)="showMore()">
                    <i class="fas fa-chevron-down me-1"></i>Ver más pagos ({{ filteredPayments.length - displayCount }} restantes)
                </button>
            </div>

            <!-- Contador -->
            <div *ngIf="filteredPayments.length > 0" class="text-center mb-2">
                <small class="text-muted fz-11">Mostrando {{ visiblePayments.length }} de {{ filteredPayments.length }} pagos</small>
            </div>

            <!-- No Data -->
            <div *ngIf="filteredPayments.length === 0 && resp_paymentsCredits.length > 0" class="text-center py-3">
                <i class="fas fa-search text-muted fz-25"></i>
                <p class="text-muted small mt-1 mb-0">No se encontraron pagos con los filtros aplicados</p>
                <button class="btn btn-sm btn-link" (click)="activeFilter='ALL'; searchTerm=''">Limpiar filtros</button>
            </div>

            <div *ngIf="resp_paymentsCredits.length === 0" class="text-center py-3">
                <i class="fas fa-money-bill-wave text-muted fz-25"></i>
                <p class="text-muted small mt-1 mb-0">No se encontraron pagos registrados</p>
            </div>

        </ng-container>
    </div>
</div>
